import React, { useEffect, useState } from 'react';
import {Alert, ThemeProvider, TextField, InputAdornment} from "@mui/material";
import styles from "../App.module.scss";
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import SearchTable from "../components/SearchTable/SearchTable";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectInstrumentsFiltered, selectIsAuthenticated, selectTags} from "../store/selectors";
import {searchTheme} from "../style/search-theme";
import {setFilters} from "../store/reducers/selectedFilters";
import {AppDispatch} from "../store";
import SearchResults from "../components/SearchResults/SearchResults";
import SecondaryHeader from "../components/Header/SecondaryHeader";
import {Print} from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';

export default function Search() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const tags = useSelector(selectTags);
  const instrumentsFiltered = useSelector(selectInstrumentsFiltered);

  const [searchText, setSearchText] = useState<string>('');

  const onFiltersChange = (filter: string[]) => dispatch(setFilters(filter));

  const filteredInstruments = React.useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return instrumentsFiltered;
    return instrumentsFiltered.filter(instr => {
      return (
        (instr.name || '').toLowerCase().includes(q) ||
        (instr.formOfSurvey || '').toLowerCase().includes(q) ||
        (instr.targetDimension || '').toLowerCase().includes(q) ||
        (instr.openAccess || '').toLowerCase().includes(q) ||
        (instr.rater || '').toLowerCase().includes(q)
      );
    });
  }, [instrumentsFiltered, searchText]);

  // warning for small screensize
  const [showWarning, setShowWarning] = React.useState(false);
  useEffect(() => {
    const checkScreenSize = () => {
      setShowWarning(window.innerWidth < 900);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return (
    <>
      <ThemeProvider theme={searchTheme}>
        <div className={styles.main}>
          <Grid container spacing={1}>
            <SecondaryHeader>
              <Grid item flex={1} alignSelf="center">
                {isAuthenticated &&
                    <Button className={styles.button} variant="contained"
                            onClick={() => navigate("/new")}>
                      Neues Instrument anlegen
                    </Button>
                }
              </Grid>
              <Grid item flex={1} textAlign="center">
                <h1 className={styles['content-title']}>Suche</h1>
              </Grid>
              <Grid item flex={1} alignSelf="center" textAlign="end">
                {isAuthenticated &&
                    <Button variant="contained" endIcon={<EditIcon/>} onClick={() => navigate("/editGroups")}>
                        Gruppen bearbeiten
                    </Button>
                }
                <Button sx={{m: "8px 0"}} variant="contained"
                        endIcon={<Print/>}
                        onClick={() => window.print()}>
                  Drucken
                </Button>
              </Grid>
            </SecondaryHeader>
            {showWarning &&
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Alert severity="warning">
                    Diese Seite ist nicht für mobile Endgeräte optimiert.
                  </Alert>
                </Grid>
            }
            <Grid item xs={12}>
              <SearchTable tags={tags} onFiltersChange={onFiltersChange}/>
              
            </Grid>
            <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Textsuche (Titel, Erhebungsform, Zieldimension, Rater, Publikation)"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <SearchResults instruments={filteredInstruments}/>
          </Grid>
        </div>
      </ThemeProvider>
    </>
  );
}